<template>
  <div class="container">
    <h1>آمار</h1>
    <hr class="mb-5">
    <div class="row">
      <div class="mt-2 col-lg-6">
        <statistic-top-sell-product/>
      </div>
      <div class="mt-2 col-lg-6">
        <statistic-top-sell-product-of-month class="h-100"/>
      </div>
      <div class="mt-2 col-lg-6">
        <static-biggest-sell class="h-100"/>
      </div>
      <div class="mt-2 col-lg-6">
        <statistic-most-viewed-product/>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticTopSellProduct from "../components/dashboard/Statistic/StatisticTopSellProduct.vue";
import StatisticTopSellProductOfMonth from "../components/dashboard/Statistic/StatisticTopSellProductOfMonth.vue";
import StaticBiggestSell from "../components/dashboard/Statistic/StaticBiggestSell.vue";
import StatisticMostViewedProduct from '../components/dashboard/Statistic/StatisticMostViewedProduct.vue'

export default {
  name: "Statistic",
  components: {StatisticMostViewedProduct, StaticBiggestSell, StatisticTopSellProductOfMonth, StatisticTopSellProduct},
}
</script>

<style scoped>

</style>